var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.987 0H9.445c-3.26 0-5.903 2.584-5.903 5.772v3.463H0v4.618h3.542v9.235h4.722v-9.235h3.542l1.181-4.618H8.264V5.772c0-.637.53-1.154 1.181-1.154h3.542V0z","fill":"#fff"}));
}

Facebook.defaultProps = {"fill":"none","viewBox":"0 0 13 24"};

module.exports = Facebook;

Facebook.default = Facebook;
